import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AI = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 18 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.97909 14.5651H14.0807C14.8755 14.5651 15.5626 14.0104 15.7302 13.2334L17.5754 4.67956C17.8022 3.62835 17.001 2.63605 15.9256 2.63623L8.68873 2.63744C8.24308 2.63751 7.81556 2.81387 7.49946 3.12801L3.53688 7.06615C3.43642 7.166 3.34892 7.2781 3.27646 7.39981L0.529116 12.0143C-0.140581 13.1392 0.669973 14.5651 1.97909 14.5651Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0602 13.2433H14.4737L16.4776 3.95703H14.2142L12.3368 12.6574L11.6003 3.95703H8.69134L3.98138 13.2433H6.51752L7.28692 11.5736H10.0154L10.0602 13.2433ZM9.87966 5.75851H9.90206H9.90338C9.89284 6.77548 9.90338 7.87137 9.93763 8.88833L9.96003 9.52735H8.22756L8.52135 8.88833C8.99696 7.87137 9.46071 6.77548 9.87966 5.75851Z"
        fill="white"
      />
    </svg>
  )
})

export default AI
